module.exports = __webpack_public_path__ + "img/17-nun.bc5f5908.svg";